import 'css-chunksrc/client/scenes/taskRemoval/taskDetails/styles.scss';export default {
  "taskDetails": "_taskDetails_12vrq_1",
  "group": "_group_12vrq_11",
  "name": "_name_12vrq_20",
  "status": "_status_12vrq_26"
};